import React from 'react'
import PropTypes from 'prop-types'
import ScoreRow from './ScoreRow'
import { useWhsTerms } from '../whs_terms_context'
const t = (key, opts) => !window.I18n ? '' : window.I18n.t(key, opts)

const ScoresTable = ({ scores, onDelete, scoreExplanations, saving, readOnly }) => {
  const whsTerms = useWhsTerms()

  if (!scores || scores.length === 0) {
    return <div className='scores-table__empty'>{t('member_handicap_history.scores_table.no_scores')}</div>
  }

  const columns = [
    { label: t('member_handicap_history.common.date'),          cls: 'col-date' },
    { label: t('member_handicap_history.common.course'),        cls: 'col-course' },
    { label: t('member_handicap_history.common.tee'),           cls: 'col-tee' },
    { label: t('member_handicap_history.common.slope', whsTerms),   cls: 'col-narrow' },
    { label: t('member_handicap_history.common.rating', whsTerms), cls: 'col-narrow' },
    { label: t('member_handicap_history.common.score'),         cls: 'col-narrow' },
    { label: t('member_handicap_history.scores_table.diff'),    cls: 'col-narrow' },
    { label: t('member_handicap_history.common.holes'),         cls: 'col-narrow' },
    { label: t('member_handicap_history.common.actions'),       cls: 'col-actions' },
  ]

  return (
    <div className='mhh-table-scroll'>
      <table className='table table-condensed table-hover scores-table'>
        <thead>
          <tr>
            {columns.map(({ label, cls }) => (
              <th key={cls + label} className={`scores-table__th scores-table__${cls}`}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {scores.map(score => (
            <ScoreRow
              key={score.id}
              score={score}
              onDelete={onDelete}
              formulaHtml={scoreExplanations[score.id]}
              saving={saving}
              readOnly={readOnly}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

ScoresTable.defaultProps = {
  readOnly: false,
  onDelete: null,
}

ScoresTable.propTypes = {
  scores: PropTypes.array,
  onDelete: PropTypes.func,
  scoreExplanations: PropTypes.object,
  saving: PropTypes.bool,
  readOnly: PropTypes.bool,
}

export default ScoresTable
